import axios from 'axios'

//Default values
const state = {}

const mutations = {}

const actions = {
    SAVE_COMPONENT: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'customers/' + payload.customer_id + '/components', payload)
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
    GET_COMPONENT: async (context, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'customers/' + payload.customer_id + '/components/' + payload.id)
            .then((res) => {
                return res.data
            })
    },
    GET_COMPONENTS: async ({rootState, commit}) => {
        return axios.get(process.env.VUE_APP_API_URL + 'components', {
            params: rootState.table.table.serverParams
        }).then((res) => {
            commit('FETCH_ITEMS', res.data)
        })
    },
    GET_CONTROL: async ({rootState, commit}) => {
        return axios.get(process.env.VUE_APP_API_URL + 'components/control', {
            params: rootState.table.table.serverParams
        }).then((res) => {
            commit('FETCH_ITEMS', res.data)
        })
    },
    UPDATE_COMPONENT: async (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(process.env.VUE_APP_API_URL + 'customers/' + payload.current_customer_id + '/components/' + payload.id, payload)
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
    DELETE_COMPONENT: async (context, payload) => {
        return axios.delete(process.env.VUE_APP_API_URL + 'customers/' + payload.customer_id + '/components/' + payload.id)
            .then((res) => {
                return res.data
            })
    },
    DROPDOWN_COMPONENT: async (context, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'customers/'
            + payload.customer + '/components/dropdown', {
            params: {
                'q': payload.query,
                'type_id': payload.type_id,
                'packet': payload.number
            }
        }).then((res) => {
            return res.data
        })
    },
}

const getters = {}

export default {
    state,
    mutations,
    actions,
    getters
}
